import { httpEnrollmentClient } from '../common/httpClient';
import { Discount } from '@/Model/discounts/types';
import API_CONST from '@/constants/ApiConst';

export function getAutomaticDiscountsByAccount(accountId: number) {
  return httpEnrollmentClient({interceptor: false}).get<Discount[]>(
    `${API_CONST.DISCOUNT}/account/${accountId}`
  );
}